import "@progress/kendo-angular-intl/locales/en/all";
import "@progress/kendo-angular-intl/locales/it/all";
import "@progress/kendo-angular-intl/locales/de/all";
import { EnvironmentProviders, inject, provideAppInitializer, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { CldrIntlService, IntlService } from "@progress/kendo-angular-intl";
import { TranslateService } from "@ngx-translate/core";
import { map, startWith } from "rxjs/operators";

const DEFAULT_LOCALE = "en";

function languageOf(translate: TranslateService): string {
    return translate.getCurrentLang() || translate.getFallbackLang() || DEFAULT_LOCALE;
}

/** Keeps Kendo's formatting (date pickers, numeric inputs) in the language the admin chose. */
export function provideKendoLocale(): EnvironmentProviders {
    return provideAppInitializer(() => {
        const translate = inject(TranslateService);
        const intl = inject(IntlService) as CldrIntlService;
        translate.onLangChange.pipe(startWith(null)).subscribe(() => (intl.localeId = languageOf(translate)));
    });
}

/**
 * The project's language, for the locale argument of `kendoDate` and `kendoNumber`: they are pure
 * pipes, so without it a value already shown would keep the language it was first drawn in.
 */
export function injectLocale(): Signal<string> {
    const translate = inject(TranslateService);
    return toSignal(translate.onLangChange.pipe(map(() => languageOf(translate))), { initialValue: languageOf(translate) });
}
